export const environment = {
  production: true,
  authUrl: 'https://auth.dev.aidwatch.net/auth/realms/aidwatch/protocol/openid-connect/token',
  baseAPIUrl: 'https://api.dev.aidwatch.net/api/v2/storage/',
  senderCommandUrl: 'https://api.dev.aidwatch.net/api/v2/sender/'
};
